import { render, staticRenderFns } from "./ShippedCard.vue?vue&type=template&id=fb33d0d2&scoped=true&"
import script from "./ShippedCard.vue?vue&type=script&lang=js&"
export * from "./ShippedCard.vue?vue&type=script&lang=js&"
import style0 from "./ShippedCard.vue?vue&type=style&index=0&id=fb33d0d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb33d0d2",
  null
  
)

export default component.exports